var exports = {
  "Sw": "GuildFolderItem.module__folderContainer___UXJaSm",
  "V8": "GuildFolderItem.module__relative___UXJaSm",
  "o6": "GuildFolderItem.module__collapsedFolder___UXJaSm",
  "yx": "GuildFolderItem.module__collapsedFolderBackground___UXJaSm",
  "sD": "GuildFolderItem.module__miniGuildIcon___UXJaSm",
  "jD": "GuildFolderItem.module__miniGuildIconWithInitials___UXJaSm",
  "mw": "GuildFolderItem.module__folderBadge___UXJaSm",
  "M8": "GuildFolderItem.module__folderBadgeActive___UXJaSm",
  "k9": "GuildFolderItem.module__expandedFolderBackground___UXJaSm",
  "MJ": "GuildFolderItem.module__folderHeader___UXJaSm",
  "mK": "GuildFolderItem.module__folderHeaderButton___UXJaSm",
  "Eh": "GuildFolderItem.module__folderIcon___UXJaSm",
  "QD": "GuildFolderItem.module__expandedGuilds___UXJaSm",
  "h5": "GuildFolderItem.module__folderTooltipContainer___UXJaSm",
  "bO": "GuildFolderItem.module__folderTooltipName___UXJaSm",
  "Il": "GuildFolderItem.module__dropIndicatorTop___UXJaSm",
  "Yc": "GuildFolderItem.module__dropIndicatorBottom___UXJaSm",
  "Zg": "GuildFolderItem.module__dropIndicatorInside___UXJaSm",
};

module.exports = exports;
